import {FloatingTree} from '@floating-ui/react';

import {DropdownContainer} from './components/DropdownContainer';
import {DropdownProps} from './types/DropdownProps';

export function Dropdown(props: DropdownProps) {
  return (
    <FloatingTree>
      <DropdownContainer
        isOpen={props.isOpen}
        onOpen={props.onOpen}
        onClose={props.onClose}
        hasSearch={props.hasSearch}
        dropdownControl={props.dropdownControl}
        isHeightLimited={props.isHeightLimited}
        isMatchingReferenceWidth={props.isMatchingReferenceWidth}
        placement={props.placement}
        data-testid={props['data-testid']}
        onButtonClick={props.onButtonClick}
        isFocusManagementDisabled={props.isFocusManagementDisabled}
        isKeyboardNavigationDisabled={props.isKeyboardNavigationDisabled}
        isDisabled={props.isDisabled}
      >
        {props.children}
      </DropdownContainer>
    </FloatingTree>
  );
}
